import * as queryString from "query-string";

export const parseSearch = <T extends Record<string, string | string[]>>(search: string) => queryString.parse(queryString.extract(search)) as T;
